module.exports = __webpack_public_path__ + "img/about-bg.5d6c1a4f.jpg";